/**
 * GraphQL operations for AppSync.
 * These are typed stubs - actual schema is defined in Amplify backend.
 */

const ADMISSIONS_QUERY_TRANSPORT = /* GraphQL */ `
  query AdmissionsTransport($operationId: String!, $input: AWSJSON) {
    domainAdmissionsQuery(operationId: $operationId, input: $input) {
      operationId
      payload
    }
  }
`;

const ADMISSIONS_MUTATION_TRANSPORT = /* GraphQL */ `
  mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {
    domainAdmissionsMutation(operationId: $operationId, input: $input) {
      operationId
      payload
    }
  }
`;

export const submitApplicationMutation = ADMISSIONS_MUTATION_TRANSPORT;
export const updateApplicationMutation = ADMISSIONS_MUTATION_TRANSPORT;
export const getApplicationQuery = ADMISSIONS_QUERY_TRANSPORT;
export const listApplicationsQuery = ADMISSIONS_QUERY_TRANSPORT;
export const listApplicationsQueryWithoutCount = ADMISSIONS_QUERY_TRANSPORT;

export const updateEnrollmentProgressMutation = /* GraphQL */ `
  mutation UpdateEnrollmentProgress($input: AWSJSON!) {
    updateEnrollmentProgress(input: $input) {
      id
      applicationId
      enrollmentProgress {
        step1AcceptanceLetter
        step2RegistrationForm
        step3B6TForm
        step4TuitionContract
        step5Payment
        step6ImmunizationRecords
        formSubmittedAt
        contractSignedAt
        paymentConfirmedAt
        immunizationVerified
      }
    }
  }
`;

export const updateMedicalRecordMutation = /* GraphQL */ `
  mutation UpdateMedicalRecord($input: AWSJSON!) {
    updateMedicalRecord(input: $input) {
      id
      applicationId
      medical {
        allergies
        chronicConditions
        medications
        immunizationStatus
        emergencyNotes
      }
    }
  }
`;

export const upsertEnrollmentStepDataMutation = /* GraphQL */ `
  mutation UpsertEnrollmentStepData($input: AWSJSON!) {
    upsertEnrollmentStepData(input: $input) {
      id
      applicationId
      enrollmentStepData {
        acceptanceLetter {
          reviewedAt
          acknowledgedBy
          notes
          documentId
          documentResourceId
        }
        tuitionContract {
          contractVersion
          signerFullName
          signedAt
          signatureToken
          totalDueCents
          installmentCount
          paymentMethod
          paymentPreferenceLabel
          paymentAmountLabel
          installmentAmountLabel
          installmentStartDate
          installmentEndDate
          thirdPartyName
          documentId
          documentResourceId
          termsAcknowledged
        }
        transportationB6t {
          requiresTransportation
          amPickupMode
          amPickupAddress
          pmDropoffMode
          pmDropoffAddress
          specialInstructions
          signerFullName
          signedAt
        }
        registrationFee {
          amountPaidCents
          currency
          paymentProvider
          transactionReference
          receiptDocumentId
          paidAt
        }
      }
    }
  }
`;

export const completeEnrollmentMutation = /* GraphQL */ `
  mutation CompleteEnrollment($input: AWSJSON!) {
    completeEnrollment(input: $input) {
      id
      status
      updatedAt
    }
  }
`;

export const lookupApplicationQuery = /* GraphQL */ `
  query LookupApplication($code: String!, $familyName: String!) {
    lookupApplication(code: $code, familyName: $familyName) {
      found
      application {
        id
        code
        applicantId
        applicant {
          id
          familyName
          homePhone
          primaryContact {
            firstName
            lastName
            email
            phone
            address {
              street
              city
              state
              zipCode
            }
          }
        }
        academicYear
        status
        assignedTo
        interviewDate
        visitDate
        children {
          id
          childInfo {
            firstName
            lastName
            currentGrade
          }
          gradeApplyingFor
          status
        }
        submittedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const updateApplicationStatusMutation = ADMISSIONS_MUTATION_TRANSPORT;
export const assignApplicationMutation = ADMISSIONS_MUTATION_TRANSPORT;
export const scheduleInterviewMutation = ADMISSIONS_MUTATION_TRANSPORT;
export const scheduleVisitMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const updateChildApplicationMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const listTimelineEventsQuery = /* GraphQL */ `
  query ListTimelineEvents($filter: AWSJSON, $limit: Int, $nextToken: String) {
    listTimelineEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        applicationId
        eventType
        isMajor
        occurredAt
        actorId
        actorRole
        summary
        metadata
      }
      nextToken
      totalCount
    }
  }
`;

export const addNoteMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const updateNoteMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const deleteNoteMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const addDocumentMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const sendApplicationMessageMutation = ADMISSIONS_MUTATION_TRANSPORT;

export const getApplicationQuickViewQuery = /* GraphQL */ `
  query GetApplicationQuickView($applicationId: String!) {
    getApplicationQuickView(applicationId: $applicationId) {
      applicationId
      familyName
      referenceCode
      students {
        id
        firstName
        lastName
        gradeApplying
        dateOfBirth
      }
      documents {
        id
        applicationId
        resourceId
        category
        fileName
        contentType
        sizeBytes
        childApplicationIds
        storageProvider
        storageKey
        storageBucket
        storageRegion
        uploadedBy
        uploadedAt
        createdAt
        updatedAt
      }
      timeline {
        id
        applicationId
        eventType
        isMajor
        occurredAt
        actorId
        actorRole
        summary
        metadata
      }
    }
  }
`;

export const listCalendarEventsQuery = /* GraphQL */ `
  query ListCalendarEvents($filter: AWSJSON) {
    listCalendarEvents(filter: $filter) {
      id
      applicationId
      childApplicationId
      eventType
      startDateTime
      endDateTime
      referenceCode
      familyName
    }
  }
`;

export const getUserPreferencesQuery = /* GraphQL */ `
  query GetUserPreferences {
    getUserPreferences {
      userId
      defaultView
      filters
      updatedAt
    }
  }
`;

export const updateUserPreferencesMutation = /* GraphQL */ `
  mutation UpdateUserPreferences($input: AWSJSON!) {
    updateUserPreferences(input: $input) {
      userId
      defaultView
      filters
      updatedAt
    }
  }
`;

export const getApplicantApplicationsQuery = /* GraphQL */ `
  query GetApplicantApplications($operationId: String!, $input: AWSJSON) {
    domainAdmissionsQuery(operationId: $operationId, input: $input) {
      operationId
      payload
    }
  }
`;

export const getFinancialAidByApplicantQuery = /* GraphQL */ `
  query GetFinancialAidByApplicant($applicantId: String!, $limit: Int, $nextToken: String) {
    getFinancialAidByApplicant(applicantId: $applicantId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        applicantId
        academicYear
        status
        createdAt
        updatedAt
      }
      nextToken
      totalCount
    }
  }
`;

export const getApplicationDocumentsQuery = /* GraphQL */ `
  query GetApplicationDocuments($operationId: String!, $input: AWSJSON) {
    domainAdmissionsQuery(operationId: $operationId, input: $input) {
      operationId
      payload
    }
  }
`;

export const getUserContactsQuery = /* GraphQL */ `
  query GetUserContacts($userId: String!, $limit: Int, $nextToken: String) {
    getUserContacts(userId: $userId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        applicationId
        type
        direction
        summary
        contactedBy
        contactedAt
        followUpRequired
        followUpDate
        followUpCompleted
        createdAt
        updatedAt
      }
      nextToken
      totalCount
    }
  }
`;

export const askAdmissionsAIMutation = /* GraphQL */ `
  mutation AskAdmissionsAI(
    $question: String!
    $conversationHistory: AWSJSON
    $context: AWSJSON
    $model: String
  ) {
    askAdmissionsAI(
      question: $question
      conversationHistory: $conversationHistory
      context: $context
      model: $model
    ) {
      answer
      module
      debug
      presentation
      actions {
        id
        label
        type
        kind
        capabilityId
        targetRoute
        requiresConfirmation
        approvalCategory
        actionCategory
        mutationOperation
        confidenceMode
        payload
      }
      citations {
        table
        key {
          id
          applicationId
          eventKey
        }
        fieldPath
        preview
        applicationCode
      }
    }
  }
`;
